// Sidebar information architecture.
//
// The sidebar used to render every route in one flat, alphabetically-sorted
// list (~40 items), which scattered related screens — "All Payments" sorted
// next to "All Supervisors", Orders nowhere near Refunds. Routes now carry a
// `group` key matching one of the entries below, and the sidebar renders them
// as collapsible sections in this order.
//
// Most groups are organised by domain (what the thing is). `support` is the
// deliberate exception: it is organised by job, collecting the screens a
// support agent reaches for when a customer contacts them. That mixed
// taxonomy is intentional — support is a distinct daily persona.
//
// Routes with `pinned: 'top' | 'bottom'` sit outside the groups entirely.
// Anything with neither `group` nor `pinned` still renders, ungrouped, above
// the bottom-pinned items, so a route can never silently vanish from the nav.

export const NAV_GROUPS = [
  { key: 'sales', label: 'Sales', icon: 'shopping_cart-simple' },
  { key: 'support', label: 'Support', icon: 'objects_support-17' },
  {
    key: 'services',
    label: 'Services & Integrations',
    icon: 'shopping_delivery-fast',
  },
  { key: 'business', label: 'Business', icon: 'shopping_shop' },
  { key: 'customers', label: 'Users & Access', icon: 'users_circle-08' },
  { key: 'risk', label: 'Risk & Compliance', icon: 'business_badge' },
  { key: 'growth', label: 'Growth & Content', icon: 'ui-2_chat-round' },
];

// Which group is currently open. Single-expand accordion; persisted so the
// sidebar looks the same after a reload.
export const EXPANDED_GROUP_KEY = 'sidebar.expandedGroup';
